import type { AppRouteRecordRaw } from '@/router/types'

export const manualOrderRoutes: AppRouteRecordRaw[] = [
  {
    path: 'manualOrder',
    name: 'ManualOrder',
    // component: () => import('@/views/manualOrder/index.vue'),
    meta: {
      title: '人工单管理后台',
      icon: 'leixingbumenshanxuanactiveno'
    },
    children: [
      {
        path: 'moLeadManage',
        name: 'MoLeadManage',
        component: () => import('@/views/manualOrder/moLeadManage/index.vue'),
        meta: {
          title: '线索管理'
        }
      },
      {
        path: 'moDataDashboard',
        name: 'MoDataDashboard',
        component: () => import('@/views/manualOrder/moDataDashboard/index.vue'),
        meta: {
          title: '数据看板'
        }
      },
      {
        path: 'moCallRecord',
        name: 'MoCallRecord',
        component: () => import('@/views/manualOrder/moCallRecord/index.vue'),
        meta: {
          title: '呼叫记录'
        }
      }
    ]
  }
]
